// @flow
import type { Element, Node } from 'React';

import React from 'react';
import { Row } from 'reactstrap';

/* eslint-disable react/jsx-props-no-spreading */
type Props = {|
  children?: Node,
  noGutters?: boolean,
  visible: boolean,
|};

const EnhancedFormGroupRow = ({
  children = null,
  noGutters = false,
  visible,
  ...rest
}: Props): Element<typeof Row> | null => {
  if (visible === false) {
    return null;
  }
  return (
    <Row noGutters={noGutters} {...rest}>
      {children}
    </Row>
  );
};

export default EnhancedFormGroupRow;
